export default "<app-jumbotron></app-jumbotron>\r\n\r\n<app-center-content></app-center-content>\r\n\r\n<app-carousel-workflow></app-carousel-workflow>\r\n"